(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core"], factory);
	else if(typeof exports === 'object')
		exports["angular4-events"] = factory(require("@angular/core"));
	else
		root["angular4-events"] = factory(root["ng"]["core"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__208__) {
return 